var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterRepost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39096 3.49789C3.23803 3.35747 2.99008 3.35747 2.83715 3.49789L0.809878 5.3593C0.618712 5.53483 0.618712 5.81941 0.809878 5.99493C1.00104 6.17046 1.31098 6.17046 1.50215 5.99493L2.62455 4.96437V10.3515C2.62455 11.5927 3.72035 12.5988 5.0721 12.5988H8.20497C8.47531 12.5988 8.69448 12.3976 8.69448 12.1494C8.69448 11.9011 8.47531 11.6999 8.20497 11.6999H5.0721C4.26105 11.6999 3.60357 11.0962 3.60357 10.3515V4.96437L4.72596 5.99493C4.91713 6.17046 5.22707 6.17046 5.41823 5.99493C5.6094 5.81941 5.6094 5.53483 5.41823 5.3593L3.39096 3.49789Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.942 12.6206C12.095 12.761 12.3429 12.761 12.4959 12.6206L14.5231 10.7592C14.7143 10.5837 14.7143 10.2991 14.5231 10.1236C14.332 9.94803 14.022 9.94803 13.8309 10.1236L12.7085 11.1541V5.76698C12.7085 4.52583 11.6127 3.51968 10.2609 3.51968H7.12804C6.85769 3.51968 6.63853 3.72091 6.63853 3.96914C6.63853 4.21737 6.85769 4.4186 7.12804 4.4186H10.2609C11.072 4.4186 11.7294 5.02229 11.7294 5.76698V11.1541L10.607 10.1236C10.4159 9.94803 10.1059 9.94803 9.91477 10.1236C9.72361 10.2991 9.72361 10.5837 9.91477 10.7592L11.942 12.6206Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterRepost);
export default __webpack_public_path__ + "static/media/twitterRepost.b912ddf5.svg";
export { ForwardRef as ReactComponent };